<div class="main-container p-4" *ngIf="currentOrgId === 10071">
	<div class="page-loading-shade" *ngIf="isProcessing">
		<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
	</div>
	<app-breadcrumb></app-breadcrumb>

	<div class="container-fluid mt-4">
		<h3 class="mb-4" style="color: #005c8a; font-weight: bold;">AI Training Data Explorer</h3>

		<!-- 4 API Buttons -->
		<div class="d-flex gap-3 mb-4 flex-wrap">
			<button mat-flat-button [style.background-color]="activeApi === 'Trainings' ? '#005c8a' : '#f2f2f2'"
				[style.color]="activeApi === 'Trainings' ? 'white' : 'black'" (click)="fetchAiData('Trainings')">
				<i class="fa fa-database me-2"></i> All Trainings
			</button>
			
			<button mat-flat-button [style.background-color]="activeApi === 'TrainingContents' ? '#005c8a' : '#f2f2f2'"
				[style.color]="activeApi === 'TrainingContents' ? 'white' : 'black'" (click)="fetchAiData('TrainingContents')">
				<i class="fa fa-file-text me-2"></i> Training Contents
			</button>
			
			<button mat-flat-button [style.background-color]="activeApi === 'UserTrainingContents' ? '#005c8a' : '#f2f2f2'"
				[style.color]="activeApi === 'UserTrainingContents' ? 'white' : 'black'" (click)="fetchAiData('UserTrainingContents')">
				<i class="fa fa-users me-2"></i> User Training Contents
			</button>
			
			<button mat-flat-button [style.background-color]="activeApi === 'TrainingQuestions' ? '#005c8a' : '#f2f2f2'"
				[style.color]="activeApi === 'TrainingQuestions' ? 'white' : 'black'" (click)="fetchAiData('TrainingQuestions')">
				<i class="fa fa-question-circle me-2"></i> Training Questions
			</button>
		</div>

		<!-- Raw JSON Response Viewer -->
		<div class="card shadow-sm mt-4" style="border: 1px solid #ccc; border-radius: 8px;">
			<div class="card-header d-flex justify-content-between align-items-center" style="background-color: #e9ecef;">
				<span class="font-weight-bold" style="font-size: 16px;">
					JSON Payload Response {{ activeApi ? ' - ' + activeApi : '' }}
				</span>
				<button mat-icon-button (click)="rawJsonResponse = null" *ngIf="rawJsonResponse" title="Clear View">
					<i class="fa fa-times text-danger"></i>
				</button>
			</div>
			
			<div class="card-body" style="background-color: #1e1e1e; min-height: 400px; max-height: 65vh; overflow: auto; padding: 20px;">
				<pre *ngIf="rawJsonResponse" style="color: #9cdcfe; font-size: 14px; white-space: pre-wrap; font-family: Consolas, monospace; margin: 0;">{{ rawJsonResponse | json }}</pre>
				
				<div *ngIf="!rawJsonResponse && !isProcessing" class="text-center" style="color: #6c757d; margin-top: 150px; font-size: 16px;">
					Click a button above to fetch the raw database view payload.
				</div>
			</div>
		</div>
	</div>
</div>
<div class="main-container" *ngIf="currentOrgId !== 10071">
	<div class="page-loading-shade" *ngIf="isProcessing">
		<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
	</div>
	<app-breadcrumb></app-breadcrumb>
	<div class="position-relative cr_content h-auto table-container">
		<div class="d-flex gap-5 col-md-12 mt-4 pt-2">
			<div class="d-flex col-md-4 flex-column align-items-center profile_box">
				<div>
					<span
						*ngIf="qmsservice.getOneQmsOrgUsersDetails == null || qmsservice.getOneQmsOrgUsersDetails == undefined">
						<i class="fa-regular fa-circle-user userimg"
							style="font-size: 35px; background: snow; margin-top: -30px;"></i>
					</span>
					<span
						*ngIf="qmsservice.getOneQmsOrgUsersDetails != null || qmsservice.getOneQmsOrgUsersDetails != undefined">
						<img alt="trnimg" class="training-userimg"
							src="data:image/*;base64,{{qmsservice.getOneQmsOrgUsersDetails.userImage}}" />
					</span>
				</div>
				<div class="user">
					<span> {{ displayUserName}} </span>
				</div>
				<div class="d-flex gap-3 mt-2">
					<div class="user_details">
						<span>
							{{ userDetails.emailAddress | lowercase }}
						</span>
					</div>
					<div class="user_details">
						<span>
							{{ userDetails.designation }}
						</span>
					</div>

				</div>
				<div class="d-flex gap-3 mt-2">
					<span class="user_details">Manager: {{ userDetails.managerName }}</span>
					<div class="d-flex align-items-center gap-1 user_details">
						<img src="../../assets/img/training_module/badge.svg" width="16px" height="16px" alt="badge" />
						<span>{{ badgeName }}</span>
					</div>
				</div>
				<div class="d-flex gap-4 mt-3">
					<div class="d-flex flex-column align-items-center pointer"
						(click)="openInformationPopup('Training Categories', $event)"
						(keydown.enter)="openInformationPopup('Training Categories', $event)">
						<div class="training_group">
							<img src="../../assets/img/training_module/training_categories.svg" width="16px"
								height="16px" alt="training categories" />
						</div>
						<p class="training_info">Training Categories</p>
						<span class="count">{{ categoryCount }}</span>
					</div>
					<div class="d-flex flex-column align-items-center pointer"
						(click)="openInformationPopup('Training Groups', $event)"
						(keydown.enter)="openInformationPopup('Training Groups', $event)">
						<div class="training_group my_total_request">
							<img src="../../assets/img/training_module/training_groups.svg" width="16px" height="16px"
								alt="training groups" />
						</div>
						<p class="training_info">Training Groups</p>
						<span class="count">{{ groupCount }}</span>
					</div>
					<div class="d-flex flex-column align-items-center pointer"
						(click)="openInformationPopup('Documents', $event)"
						(keydown.enter)="openInformationPopup('Documents', $event)">
						<div class="training_group other_request">
							<img src="../../assets/img/training_module/documents.svg" width="16px" height="12px"
								alt="documents" />
						</div>
						<p class="training_info">Documents</p>
						<span class="count">{{ documentsCount }}</span>
					</div>

					<div class="d-flex flex-column align-items-center pointer" (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
						<div class="training_group my_total_request">
							<img src="../../assets/img/training_module/pdf1.svg" width="16px" height="16px"
								alt="My Training Report" />
						</div>
						<p class="training_info">My Training Report</p>
						<span class="count">{{ reportCount }}</span>
					</div>
				</div>
			</div>
			<div class="d-flex col-md-7 flex-column">
				<div class="d-flex justify-content-end search_block" style="width: 100%;padding: 10px;">
					<div class="d-flex gap-3 align-items-center ">

						<div class="">
							<input class="input-filed-continers" type="text" [(ngModel)]="trainingCode"
								placeholder="Training Code" />
						</div>
						<div class="">
							<input class="input-filed-continers" type="text" [(ngModel)]="trainingName"
								placeholder="Training Name" />
						</div>
						<div class="trainingDashboard">
							<ng-multiselect-dropdown id="category" class="multiselect-container"
								[(ngModel)]="selectedTrainingCategory" [settings]="singleSelectDropdownSetting"
								[data]="categoryDropdown" (onSelect)="onCategorySelect($event)"
								(onDeSelect)="onCategoryRemoved($event)" placeholder="Select Category">
							</ng-multiselect-dropdown>
						</div>
						<div class="">
							<div class="search-container">
								<input type="text" class="input-filed-continers" placeholder="Group Name"
									[(ngModel)]="trainingGroup" (click)="searchTrainingGroupsFunc()" readOnly />
							</div>
						</div>
						<div class=" d-flex gap-3">
							<div class="search_icon_block d-flex align-items-center justify-content-center pointer"
								(click)="searchTrainings()" (keydown.enter)="searchTrainings()">
								<img src="../../assets/img/training_module/search_icon.svg" width="12px" height="12px"
									alt="" />
							</div>
							<div class="redo_block d-flex align-items-center justify-content-center pointer"
								(click)="resetSearchTraining()" (keydown.enter)="resetSearchTraining()">
								<img src="../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="" />
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex gap-4 mt-3">
					<div class="col-md-4" style="width: 38%;">
						<div class="thumbnail dashTopRow">
							<div>
								<h5 class="training_title">My Trainings</h5>
							</div>
							<div class="d-flex justify-content-start">
								<div class="myTrainingLeftPlace">
									<div>
										<div class="" *ngFor="let status of trainingCountList,let i=index;">
											<div *ngIf="
						  status.levelStatus != 'Locked - Overdue(RM Approved)'
						">
												<button class="d-flex trainingDashButton ps-2" mat-stroked-button
													(click)="
							viewStatuswiseTraining1($event, status.levelStatus,i+'_'+status.levelStatus)
						  ">
													<div class="d-flex gap-1">
														<div class="mark" [ngStyle]="applyStyle(status.color)"></div>
														<span>{{ status.levelStatus }} ({{
															status.trainingCount
															}})</span>
													</div>
												</button>
											</div>
											<div *ngIf="
						  status.levelStatus == 'Locked - Overdue(RM Approved)'
						">
												<button class="d-flex trainingDashButton ps-2"
													[ngStyle]="applyStyle('#92c278')" mat-stroked-button (click)="
							viewStatuswiseTraining1($event, status.levelStatus,i+'_'+status.levelStatus)
						  ">
													Locked - Overdue(RM) ({{ status.trainingCount }})
												</button>
											</div>
										</div>
									</div>
								</div>
								<div class="">
									<div class="dgm">
										<canvas class="MyChart"></canvas>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-4" style="width: 35%;">
						<div class="thumbnail dashTopRow">
							<div>
								<h5 class="training_title">Team Trainings</h5>
							</div>
							<div class="d-flex justify-content-between">
								<div class="">
									<div>
										<button class="trainingDashButton ps-2" mat-stroked-button
											(click)="goToTeamMemberPage('Team Members')">
											<div class="d-flex align-items-center gap-1">
												<div class="mark" [ngStyle]="applyStyle('#6B7887')"></div>
												<span>Members ({{ managerCount }})</span>
											</div>
										</button>
									</div>
									<div>
										<button class="trainingDashButton ps-2" mat-stroked-button
											(click)="goToTeamMemberPage('Completed')">
											<div class="d-flex align-items-center gap-1">
												<div class="mark" [ngStyle]="applyStyle('#96E480')"></div>
												<span>Completed ({{ totalCompleted }})</span>
											</div>
										</button>
									</div>
									<div>
										<button class="trainingDashButton px-2" mat-stroked-button
											(click)="goToTeamMemberPage('Not Completed')">
											<div class="d-flex align-items-center gap-1 ">
												<div class="mark" [ngStyle]="applyStyle('#BA7393')"></div>
												<span>Not Completed ({{ totalNotCompleted }})</span>
											</div>
										</button>
									</div>
								</div>
								<div>
									<canvas id="MyChartForTeamMember"></canvas>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-3">
						<div class="thumbnail dashTopRow">
							<div>
								<h5 class="training_title">Training Actions</h5>
							</div>
							<div>
								<div class="myTrainingLeftPlace">
									<div *ngFor="let task of trainingTaskDetails; let i = index">
										<div *ngIf="i % 2 == 0">
											<button class="trainingDashButtonForAction" mat-stroked-button
												(click)="goToManagePage1(task,i+'_'+task.status)">
												<div class="d-flex align-items-center gap-1">
													<div class="mark" [ngStyle]="applyStyle('#834160')"></div>
													<span>{{ task.status }} ({{ task.cnt }})</span>
												</div>
											</button>
										</div>
										<div *ngIf="i % 2 == 1">
											<button class="trainingDashButtonForAction" mat-stroked-button
												(click)="goToManagePage1(task,i+'_'+task.status)">
												<div class="d-flex align-items-center gap-1">
													<div class="mark" [ngStyle]="applyStyle('#0081A5')"></div>
													<span>{{ task.status }} ({{ task.cnt }})</span>
												</div>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="d-none panel" style="margin-top: 8px">
			<div class="panel-body">
				<div class="row">
					<div class="col-md-3 col-lg-3 col-sm-3">
						<div class="thumbnail dashTopRow">
							<div class="row" style="padding: 2%; padding-bottom: 0">
								<h5 style="font-size: 16px; font-weight: 700">My Trainings</h5>
							</div>
							<div class="row">
								<div class="col-md-5">
									<div class="dgm">
										<div class="totalTrainings">
											{{ badgeName }} ({{ trainingCount }})
										</div>
										<canvas class="MyChart" [ngStyle]="addBadges(badgeName)"></canvas>
									</div>
								</div>
								<div class="col-md-7" style="padding-left: 0px">
									<div style="overflow-y: auto; height: 180px; overflow-x: hidden">
										<div class="row" *ngFor="let status of trainingCountList"
											style="padding-left: 10%; margin-bottom: 3px">
											<div style="margin-bottom: 0px" *ngIf="
						  status.levelStatus != 'Locked - Overdue(RM Approved)'
						">
												<button class="trainingDashButton" [ngStyle]="applyStyle(status.color)"
													style="padding-left: 5px; padding-right: 5px" mat-stroked-button
													(click)="
							viewStatuswiseTraining($event, status.levelStatus,'index')
						  ">
													{{ status.levelStatus }} ({{ status.trainingCount }})
												</button>
											</div>
											<div style="margin-bottom: 0px" *ngIf="
						  status.levelStatus == 'Locked - Overdue(RM Approved)'
						">
												<button class="trainingDashButton" [ngStyle]="applyStyle('#92c278')"
													style="padding-left: 5px; padding-right: 5px" mat-stroked-button
													(click)="
							viewStatuswiseTraining($event, status.levelStatus,'index')
						  ">
													Locked - Overdue(RM) ({{ status.trainingCount }})
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-3 col-lg-3 col-sm-3">
						<div class="thumbnail dashTopRow">
							<div class="row text-center" style="padding: 2%; padding-bottom: 0">
								<h5 style="font-size: 16px; font-weight: 700">Team Trainings</h5>
							</div>

							<div class="row">
								<div style="margin-bottom: 3px; margin-left: 25%">
									<button class="trainingDashButton" [ngStyle]="applyStyle('#ffd685')"
										mat-stroked-button (click)="goToTeamMemberPage('Team Members')">
										Members ({{ managerCount }})
									</button>
								</div>
								<div style="margin-bottom: 3px; margin-left: 25%">
									<button class="trainingDashButton" [ngStyle]="applyStyle('#92c278')"
										mat-stroked-button (click)="goToTeamMemberPage('Completed')">
										Completed ({{ totalCompleted }})
									</button>
								</div>
								<div style="margin-bottom: 3px; margin-left: 25%">
									<button class="trainingDashButton" [ngStyle]="applyStyle('#f5b297')"
										mat-stroked-button (click)="goToTeamMemberPage('Not Completed')">
										Not Completed ({{ totalNotCompleted }})
									</button>
								</div>
							</div>
							<div class="row">
								<canvas id="MyChartForTeamMember"></canvas>
							</div>
						</div>
					</div>
					<div class="col-md-3 col-lg-3 col-sm-3">
						<div class="thumbnail dashTopRow">
							<div class="row text-center" style="padding: 2%; padding-bottom: 0">
								<h5 style="font-size: 16px; font-weight: 700">
									Training Actions
								</h5>
							</div>
							<div class="row text-center">
								<div style="overflow-y: auto; height: 200px; overflow-x: hidden">
									<div style="margin-bottom: 0px"
										*ngFor="let task of trainingTaskDetails; let i = index">
										<div style="
						margin-left: 15%;
						margin-bottom: 5px;
					  " *ngIf="i % 2 == 0">
											<button class="trainingDashButtonForAction"
												[ngStyle]="applyStyle('#ffd685')" mat-stroked-button>
												{{ task.status }} ({{ task.cnt }})
											</button>
										</div>
										<div style="
						margin-left: 15%;
						margin-bottom: 5px;
					  " *ngIf="i % 2 == 1">
											<button class="trainingDashButtonForAction"
												[ngStyle]="applyStyle('#b5bab6')" mat-stroked-button>
												{{ task.status }} ({{ task.cnt }})
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-3 col-lg-3 col-sm-3">
						<div class="thumbnail dashTopRow">
							<div class="row text-center" style="padding: 2%; padding-bottom: 0">
								<h5 style="font-size: 16px; font-weight: 700">
									Personal Profile
								</h5>
							</div>
							<div class="row">
								<div class="col-md-12" style="
					height: 195px;
					overflow-y: auto;
					width: 95%;
					overflow-x: hidden;
				  ">
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500"
												for="email">Name:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default">{{
												userDetails.firstName }},
												{{ userDetails.lastName }}</span>
										</button>
									</div>
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500"
												for="email">Email:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default">{{
												userDetails.emailAddress | lowercase }}</span>
										</button>
									</div>
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500"
												for="email">Designation:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default">{{
												userDetails.designation }}</span>
										</button>
									</div>
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500"
												for="email">Manager:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default">{{
												userDetails.managerName }}</span>
										</button>
									</div>
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500" for="email">Training
												Categories:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default"><a href=""
													(click)="
							openInformationPopup('Training Categories', $event)
						  ">{{ categoryCount }}</a></span>
										</button>
									</div>
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500" for="email">Training
												Groups:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default"><a href=""
													(click)="
							openInformationPopup('Training Groups', $event)
						  ">{{ groupCount }}</a></span>
										</button>
									</div>
									<div class="cus">
										<button class="trainingDashButtonForprofile" [ngStyle]="applyStyle('#f2f2f2')"
											mat-stroked-button>
											<label class="control-label" style="font-weight: 500"
												for="email">Documents:</label>
											<span style="font-size: 12px; font-weight: 400; cursor: default"><a href=""
													(click)="openInformationPopup('Documents', $event)">{{
													documentsCount }}</a></span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-4">
			<div class="">
				<div class="">
					<ul class="breadcrumb">
						<li class="pointer" (click)="openMainTab('My Trainings')"
							(keydown.enter)="openMainTab('My Trainings')">
							<a [ngClass]="{'active': selectedWizard === 'My Trainings'}">My Trainings</a>
						</li>
						<li class="pointer" (click)="openMainTab('Team Trainings')"
							(keydown.enter)="openMainTab('Team Trainings')">
							<a [ngClass]="{'active': selectedWizard === 'Team Trainings'}">Team Trainings</a>
						</li>
						<li class="pointer" (click)="openMainTab('Training Actions')"
							(keydown.enter)="openMainTab('Training Actions')">
							<a [ngClass]="{'active': selectedWizard === 'Training Actions'}">Training Actions</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="" *ngIf="selectedWizard == 'My Trainings'">
				<div class="">
					<div class="">
						<button *ngFor="let status of trainingCountList;let i = index" mat-stroked-button
							class="sub_items me-2 mb-4 mt-2" [ngStyle]="applyStyleForTraining(status.color)"
							[class.active]="i+'_'+status.levelStatus == selectedTraining"
							(click)="viewStatuswiseTraining($event, status.levelStatus,i+'_'+status.levelStatus)">
							{{ status.levelStatus }}
						</button>

						<div class="thumbnail mb-5">
							<div class="row d-flex align-items-center">
								<div class="col-md-1" style="width:2%;">
									<span *ngIf="isPrevious" class="fa fa-angle-left"
										style="font-size: 30px; cursor: pointer" (click)="previousClick(trainingList)"
										(keydown.enter)="previousClick(trainingList)"></span>
									<span *ngIf="!isPrevious" class="fa fa-angle-left"
										style="font-size: 30px; opacity: 0.4; cursor: not-allowed"></span>
								</div>
								<div class="col-md-10" style="width:95.5%;">
									<div class="row">
										<div class="col-md-3 card_dimension" *ngFor="
						let training of trainingList.slice(
						  initialCount,
						  pageCount
						)
					  ">
											<div class="thumbnail my-2">
												<div class="caption">
													<div class="container">
														<img alt="no" class="img" *ngIf="training.trainingImage == null"
															src="../../assets/img/missing.jpg" />
														<img alt="yes" class="img"
															*ngIf="training.trainingImage != null" src="data:image/jpg;base64,{{
								training.trainingImage
							  }}" />

														<div class="text-block-left">
															<p class="type">{{ training.type }}</p>
														</div>
													</div>

													<div class="thumbnail-description smaller">
														<div class="d-flex justify-content-between">
															<div>
																<p class="trainingname text"
																	title="{{ training.trainingName }}">
																	{{ training.trainingName }}(v{{
																	training.version
																	}})
																</p>
																<div class="d-flex align-items-center gap-3 mt-3">
																	<span class="card_details">Status :</span>
																	<span class="card_details"
																		[ngClass]="training.status === 'Completed' ? 'closed' : training.status === 'Draft' ? 'draft' : training.status === 'Failed' ? 'delete': 'approve'">{{
																		training.status
																		}}</span>
																</div>
															</div>
															<div class="circular_indicator"
																*ngIf="training.levelStatus == 'In Progress' || training.levelStatus == 'Completed'">
																<mat-progress-spinner [color]="color" [value]="value">
																</mat-progress-spinner>
																<span class="progress_percentage"
																	*ngIf="training.levelStatus == 'In Progress'">{{
																	training.progress }}%</span>
																<span class="progress_percentage"
																	*ngIf="training.levelStatus == 'Completed'">100%</span>
															</div>
														</div>


														<div class="author">
															<div class="card_details author mt-3">
																<span class="authorName">Language : {{ training.language
																	}}</span>
																<span class="authorName"
																	*ngIf="training.groupName != null">Group : {{
																	training.groupName }}</span>
																<span class="authorName"
																	*ngIf="training.trainerName != null"
																	matTooltip="{{ training.trainerName }}"
																	matTooltipPosition="above">Trainer : {{
																	training.trainerName }}</span>
															</div>
														</div>

														<span *ngIf="training.status == 'Completed'"
															class="card_details author">Completed On :{{
															training.completedOn
															| date : "dd-MMM-yyyy HH:mm:ss"
															}}</span><br *ngIf="training.status == 'Completed'" />
														<span *ngIf="
								training.status != 'Completed' &&
								training.dueDate != null
							  " class="card_details author">Due Date :
															{{
															training.dueDate | date : "dd-MMM-yyyy HH:mm:ss"
															}}
															<span *ngIf="training.dueDate != null">
																<span *ngIf="!training.isOverdue">(Due)</span>
																<span *ngIf="training.isOverdue >= date"
																	style="color: red">(Overdue)</span>
															</span>
														</span>
														<br *ngIf="
								training.status != 'Completed' &&
								training.dueDate == null
							  " />
													</div>
													<div class="d-flex justify-content-between">
														<div *ngIf="training.totalDuration">
															<p class="status duration card_details">
																{{ training.totalDuration }}
															</p>
														</div>

														<div class="text-center">
															<button class="open_cta" mat-stroked-button
																(click)="launchTrainingFunc(training)">
																Open
															</button>
														</div>
													</div>
												</div>
												<div class="caption card-footer text-center"></div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-1" style="width:2%;">
									<span *ngIf="isNext" class="fa fa-angle-right"
										style="font-size: 30px; cursor: pointer" (click)="nextClick(trainingList)"
										(keydown.enter)="nextClick(trainingList)"></span>
									<span *ngIf="!isNext" class="fa fa-angle-right"
										style="font-size: 30px; opacity: 0.4; cursor: not-allowed"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="" *ngIf="selectedWizard == 'Team Trainings'">
				<div class="">
					<div class="">
						<div class="">
							<div class="button-continer">
								<button mat-stroked-button
									[ngClass]="{'active': selectedSubWizardofTeam === 'Team Members'}"
									class="sub_items me-2" (click)="openSubTabOfTeam('Team Members')">
									Team Members
								</button>
								<button mat-stroked-button
									[ngClass]="{'active': selectedSubWizardofTeam === 'Completed'}"
									class="sub_items me-2" (click)="openSubTabOfTeam('Completed')">
									Completed
								</button>
								<button mat-stroked-button
									[ngClass]="{'active': selectedSubWizardofTeam === 'Not Completed'}"
									class="sub_items" (click)="openSubTabOfTeam('Not Completed')">
									Not Completed
								</button>


							</div>
						</div>
					</div>
					<div class="" *ngIf="selectedSubWizardofTeam == 'Team Members'">
						<div class="">
							<app-team-trainings [value1]="'Members'" [teamMembers]="memberData"></app-team-trainings>
						</div>
					</div>
					<div class="" *ngIf="
			  selectedSubWizardofTeam == 'Completed' ||
			  selectedSubWizardofTeam == 'Not Completed'
			">
						<div class="thumbnail mt-3">
							<div class="table-container">
								<div class="row">
									<div class="col-md-8" *ngIf="selectedSubWizardofTeam == 'Completed'"></div>
									<div class="col-md-8"
										*ngIf="selectedSubWizardofTeam != 'Completed' && tmsUserTrainingsRepVwDataForGrid1!=null">
										<span *ngFor="let STATUS of tmsUserTrainingsRepVwDataForGrid1;let i = index">
											<div class="float-end mb-3" *ngIf="STATUS != 'Completed'">
												<button mat-stroked-button class="sub_items me-2 mb-4 mt-2"
													[class.active]="selectedSubWizardofTeam === 'Not Completed' && STATUS == selectedTeamTraining"
													(click)="openSubTabOfTeamNotCompleted(STATUS)">
													{{STATUS}}
												</button>
											</div>
										</span>
									</div>
									<div class="col-md-4">
										<div id="header-container" class="">
											<div class="float-end mb-3">
												<div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
													(click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
													<i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
													<span class="reload_text text-white">PDF Report</span>
												</div>
											</div>
											<div class="float-end mb-3">
												<div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
													(click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
													<i class="fa fa-file-excel-o"
														style="font-size:18px;color:white"></i>
													<span class="reload_text text-white">Excel Report</span>
												</div>
											</div>
											<div class="float-end mb-3">
												<div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
													*ngIf="message.dataGridAdmin" (click)="openReorder()"
													(keydown.enter)="openReorder()">
													<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
														viewBox="0 0 20 20" fill="#ffffff">
														<path style="fill:'#FFFFFF'"
															d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
													</svg>
													<span class="reload_text text-white">Settings</span>
												</div>
											</div>
											<div class="float-end mb-3">
												<div class="search-container">
													<span class="fa fa-search form-control-feedback"></span>
													<input type="text" class="form-control search_input"
														style="font-size: 13px" placeholder="Search"
														(input)="globalFilter($event)" [(ngModel)]="searchValue" />
												</div>
											</div>

										</div>
									</div>
								</div>


								<table class="vendors-table-container">
									<th id="grid-header-container" *ngFor="
					  let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
					  let ix = index
					" [ngStyle]="{
					  'min-width': oneQmsUsersDataForTable1Data.width
					}" class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
										<div
											class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
											<span>{{
												oneQmsUsersDataForTable1Data.fieldColumnarray
												}}</span>
											<div class="d-flex gap-2 align-items-center">
												<div>
													<img src="../../assets/img/qms_img/sort.svg" width="9px"
														height="16px" alt="sort" />
												</div>
												<div>
													<img src="../../assets/img/qms_img/filter.svg" width="24px"
														height="24px" alt="filter" />
												</div>
											</div>

										</div>
									</th>
									<tr>
										<td *ngFor="
						let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
						let ix = index
					  " [ngStyle]="{
						'min-width': oneQmsUsersDataForTable1Data.width
					  }" class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
											<div class="row-search-container">
												<input type="text" class="form-control" placeholder="Search" (input)="
							coloumnFilter3(columnLists.columnsListarray[ix], $event)
						  " />
											</div>
										</td>
									</tr>
									<!-- data row -->
									<tr *ngFor="
					  let list of pagedItemsForTeam | searchFilter : searchValue;
					  let idx = index
					">
										<td id="grid-row-container" *ngFor="
						let key of columnLists.columnsListarray1;
						let i = index
					  " class="sticky-dynamic-row1" [ngStyle]="{
						'min-width': key.width[i],
						'max-width': key.width[i],
						overflow: 'hidden',
						'text-overflow': 'ellipsis',
						'white-space': 'nowrap'
					  }" (mouseover)="cssfunction(i)" (focus)="focusEmpty()">
											<span *ngIf="key.dataType == 'CHECKBOX'">
												<div class="gridCheckBoxes">
													<img *ngIf="list[key.columnsListarray]"
														src="../../assets/img/cr_module/accessSymbol.svg" width="16"
														height="16" alt="access" />
													<img *ngIf="list[key.columnsListarray] == false"
														src="../../assets/img/cr_module/noAcessSymbol.svg" width="16"
														height="16" alt="no access" />
												</div>
											</span>
											<span *ngIf="
						  key.dataType != 'CHECKBOX' && key.dataType != 'DATE'
						">{{ list[key.columnsListarray] }}</span>
											<span *ngIf="key.dataType == 'DATE'">{{
												list[key.columnsListarray]
												}}</span>
										</td>
										<td class="sticky-col first-col">
											<div class="action-icons"></div>
										</td>
									</tr>
								</table>
								<div class="d-flex justify-content-center">
									<div class="width-cheat small paginationCell">
										<div class="d-flex align-items-center gap-3">
											<div class="pagination_text mt-3">
												{{ showingRowsText }}
												1-{{ perPage }} of {{ collectionSize | number }}
											</div>
											<div>
												<ngb-pagination class="leftpadding"
													(pageChange)="setPage1(pager.currentPage, $event)"
													[disabled]="false" [collectionSize]="pager.totalItems"
													[(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
													[pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
													size="sm">
												</ngb-pagination>
											</div>
											<div ngbDropdown class="pagination_text mt-3">
												<button class="btn btn-primary btn-sm mr-1 pagination_text bg-white"
													id="dropdownBasic1" ngbDropdownToggle>
													{{ perPage }}
													<i class="ms-1 fa-solid fa-chevron-down"></i>
												</button>
												<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
													<button ngbDropdownItem (click)="paginationCall1(10)">
														10
													</button>
													<button ngbDropdownItem (click)="paginationCall1(20)">
														20
													</button>
													<button ngbDropdownItem (click)="paginationCall1(50)">
														50
													</button>
												</div>
												per page
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="" *ngIf="selectedWizard == 'Training Actions'">
				<div class="">
					<div class="">
						<div class="">
							<div class="button-continer">
								<button mat-stroked-button class="sub_items me-2"
									*ngFor="let task of trainingTaskDetails;let i=index"
									[class.active]="i+'_'+task.status == selectedTraining"
									(click)="goToManagePage(task,i+'_'+task.status)">
									{{ task.status }}
								</button>
							</div>
							<br>
							<div class="thumbnail mb-5">
								<div class="row d-flex align-items-center">
									<div class="col-md-1" style="width:2%;">
										<span *ngIf="isPrevious" class="fa fa-angle-left"
											style="font-size: 30px; cursor: pointer"
											(click)="previousClick(trainingActionsList)"
											(keydown.enter)="previousClick(trainingActionsList)"></span>
										<span *ngIf="!isPrevious" class="fa fa-angle-left"
											style="font-size: 30px; opacity: 0.4; cursor: not-allowed"></span>
									</div>
									<div class="col-md-10" style="width:95.5%;">
										<div class="row">
											<div class="col-md-3 card_dimension" *ngFor="
							  let training of trainingActionsList.slice(
								initialCount,
								pageCount
							  )
							">
												<div class="thumbnail my-2">
													<div class="caption">
														<div class="container">
															<img alt="no" class="img"
																*ngIf="training.trainingImage == null"
																src="../../assets/img/missing.jpg" />
															<img alt="yes" class="img"
																*ngIf="training.trainingImage != null" src="data:image/jpg;base64,{{
									  training.trainingImage
									}}" />
														</div>

														<div class="thumbnail-description smaller">
															<div class="d-flex justify-content-between">
																<div>
																	<p *ngIf="!training.status.includes('Locked')"
																		class="trainingname text" title="{{ training.taskName }}(v{{
											training.version
										  }})">
																		{{ training.taskName }}(v{{
																		training.version
																		}})
																	</p>
																	<p *ngIf="training.status.includes('Locked')"
																		class="trainingname text" title="{{ training.taskName }}(v{{
											training.newVersion
										  }})">
																		{{ training.taskName }}(v{{
																		training.newVersion
																		}})
																	</p>
																	<div class="d-flex align-items-center gap-3 mt-3">
																		<span class="card_details">Status :</span>
																		<span class="card_details"
																			[ngClass]="training.status === 'Completed' ? 'closed' : training.status === 'Draft' ? 'draft' : training.status === 'Failed' ? 'delete': 'approve'">{{
																			training.status
																			}}</span>
																	</div>
																</div>
																<div class="circular_indicator"
																	*ngIf="training.levelStatus == 'In Progress' || training.levelStatus == 'Completed'">
																	<mat-progress-spinner [color]="color"
																		[value]="value">
																	</mat-progress-spinner>
																	<span class="progress_percentage"
																		*ngIf="training.levelStatus == 'In Progress'">{{
																		training.progress }}%</span>
																	<span class="progress_percentage"
																		*ngIf="training.levelStatus == 'Completed'">100%</span>
																</div>
															</div>
															<div class="author">
																<div class="card_details author mt-3">
																	<!-- <span *ngIf="!training.status.includes('Locked')"
																		class="authorName">Language : {{
																		training.language }}</span> -->
																	<span *ngIf="!training.status.includes('Locked')"
																		class="authorName">Author : {{
																		training.taskOwnerUserName }}</span>
																	<span *ngIf="training.status.includes('Locked')"
																		class="authorName">Trainee : {{
																		training.requesterUserName }}</span>
																</div>
															</div>

															<span *ngIf="!training.status.includes('Locked')"
																class="card_details author">Requested On:{{
																training.actionRequestedOn
																| date : "dd-MMM-yyyy HH:mm:ss"
																}}</span><br
																*ngIf="!training.status.includes('Locked')" />
															<span *ngIf="
									  training.status.includes('Locked')
									" class="card_details author">Due Date :
																{{
																training.dueDate | date : "dd-MMM-yyyy HH:mm:ss"
																}}

															</span>
															<br *ngIf="
								  training.status.includes('Locked')
								" />
														</div>
														<div class="d-flex justify-content-between">
															<div *ngIf="training.totalDuration">
																<p class="status duration card_details">
																	{{ training.totalDuration }}
																</p>
															</div>

															<div class="text-center">
																<button class="open_cta" mat-stroked-button
																	(click)="updateTrainingFunc(training)">
																	Open
																</button>
															</div>
														</div>
													</div>
													<div class="caption card-footer text-center"></div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-1" style="width:2%;">
										<span *ngIf="isNext" class="fa fa-angle-right"
											style="font-size: 30px; cursor: pointer"
											(click)="nextClick(trainingActionsList)"
											(keydown.enter)="nextClick(trainingActionsList)"></span>
										<span *ngIf="!isNext" class="fa fa-angle-right"
											style="font-size: 30px; opacity: 0.4; cursor: not-allowed"></span>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
	<ng-template #searchTrainingpopup>
		<div class="ng-template-container">
			<div class="page-loading-shade" *ngIf="isProcessing">
				<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
			</div>
			<button class="close close-button" (click)="cancelSearchTrainingPopup()" mat-button>
				<i class="fa popupClose">&#xf00d;</i>
			</button>

			<div mat-dialog-title>
				<label for="title" class="popupTitle">Trainings</label>
				<label for="pop" class="popupAppTitle">One<span style="color: gold">QMS</span>
				</label>
			</div>
			<div class="form-continer">
				<div class="d-none table-container">
					<div class="header-container" class="row">
						<div class="col-md-4">
							<div class="row-search-container">
								<input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
									[(ngModel)]="searchValue" />
							</div>
						</div>
						<div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
							{{ showingRowsText }}
							1-{{ perPage }} of {{ collectionSize | number }}
							<ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
								[disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
								[maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
								[boundaryLinks]="true" size="sm">
							</ngb-pagination>
							<div ngbDropdown class="d-inline-block leftpadding">
								<button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
									{{ perPage }}
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
									<button ngbDropdownItem (click)="paginationCall(10)">10</button>
									<button ngbDropdownItem (click)="paginationCall(20)">20</button>
									<button ngbDropdownItem (click)="paginationCall(50)">50</button>
								</div>
								per page
							</div>
						</div>
					</div>
					<table class="dynamic-table-container">
						<th>
							<span>Training Name</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Version</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Code</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span> Catgeory</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Type</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Language</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Self Assignable?</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Group</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th id="menu" class="sticky-col first-col"></th>
						<tr class="data-row-container" *ngFor="
				let training of pagedItems | searchFilter : searchValue;
				let idx = index
			  ">
							<td class="row-data">
								<a href="" (click)="goToDetailPage(training, $event)">{{
									training.trainingName
									}}</a>
							</td>
							<td class="row-data" style="min-width: 80px">
								{{ training.version }}
							</td>
							<td class="row-data" style="min-width: 120px">
								{{ training.trainingCode }}
							</td>
							<td class="row-data">{{ training.categoryCode }}</td>
							<td class="row-data">{{ training.type }}</td>
							<td class="row-data" style="min-width: 100px">
								{{ training.language }}
							</td>
							<td class="grid-row-container" style="
				  text-align: left;
				  overflow: hidden;
				  text-overflow: 'ellipsis';
				  white-space: 'nowrap';
				">
								<span>
									<div class="gridCheckBoxes">
										<img alt="yes" *ngIf="training.selfAssignable == 'Y'"
											src="../../assets/img/accessSymbol.svg" width="20" height="20" />
										<img alt="no" *ngIf="training.selfAssignable == 'N'"
											src="../../assets/img/noAcessSymbol.svg" width="20" height="20" />
									</div>
								</span>
							</td>
							<td class="row-data">{{ training.groupName }}</td>
						</tr>
					</table>

				</div>

				<div class="table-container">
					<div class="d-flex justify-content-end gap-3 mt-1 mb-3 header-container">
						<div class="">
							<div class="row-search-container">
								<input type="text" class="form-control search_input" style="font-size: 13px;"
									placeholder="Search" [(ngModel)]="searchValue">
							</div>
						</div>
					</div>

					<table class="dynamic-table-container documentTable" style="height: 50vh;">
						<thead>
							<th
								[ngStyle]="{'min-width': '180px', 'max-width': '180px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Training Name</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Version</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Training Code</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Category</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Type</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Langauge</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Self Assignable?</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '180px', 'max-width': '180px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Group</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
						</thead>
						<tbody>
							<tr class="data-row-container" *ngFor="let training of pagedItems; let idx = index">
								<td class="row-data">
									<a href="" (click)="goToDetailPage(training, $event)">{{
										training.trainingName
										}}</a>
								</td>
								<td class="row-data" style="min-width: 80px">
									{{ training.version }}
								</td>
								<td class="row-data" style="min-width: 120px">
									{{ training.trainingCode }}
								</td>
								<td class="row-data">{{ training.categoryCode }}</td>
								<td class="row-data">{{ training.type }}</td>
								<td class="row-data" style="min-width: 100px">
									{{ training.language }}
								</td>
								<td class="grid-row-container" style="
					text-align: left;
					overflow: hidden;
					text-overflow: 'ellipsis';
					white-space: 'nowrap';
				  ">
									<span>
										<div class="gridCheckBoxes">
											<img alt="yes" *ngIf="training.selfAssignable == 'Y'"
												src="../../assets/img/accessSymbol.svg" width="20" height="20" />
											<img alt="no" *ngIf="training.selfAssignable == 'N'"
												src="../../assets/img/noAcessSymbol.svg" width="20" height="20" />
										</div>
									</span>
								</td>
								<td class="row-data">{{ training.groupName }}</td>
							</tr>
						</tbody>
					</table>
					<div class="row header-container">

						<div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
							{{ showingRowsText }}
							1-{{ perPage }} of {{ collectionSize | number }}
							<ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
								[disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
								[maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
								[boundaryLinks]="true" size="sm">
							</ngb-pagination>
							<div ngbDropdown class="d-inline-block leftpadding">
								<button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
									{{ perPage }}
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
									<button ngbDropdownItem (click)="paginationCall(10)">10</button>
									<button ngbDropdownItem (click)="paginationCall(20)">20</button>
									<button ngbDropdownItem (click)="paginationCall(50)">50</button>
								</div>
								per page
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template #searchTrainingGroupPopup>
		<div class="page-loading-shade" *ngIf="isProcessing">
			<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
		</div>
		<button class="close close-button" (click)="cancelSearchTrainingGroupFunction()" mat-button>
			<i class="fa popupClose">&#xf00d;</i>
		</button>
		<div mat-dialog-title>
			<label for="title" class="popupTitle">Search Training Group</label>
			<label for="pop" class="popupAppTitle">One<span style="color: gold">QMS</span>
			</label>
		</div>
		<div id="filed-container" class="form-continer" style="height: 520px !important;">
			<div class="row">
				<div class="col-md-3">
					<div><label for="email ">Group Name</label></div>
					<input class="search-filed-continers uppercase" type="text" placeholder="Enter Group Name"
						[(ngModel)]="searchByGroupName" />
				</div>
			</div>
			<div class="row fieldstyle">
				<div class="search-button-continer" mat-dialog-actions>
					<button mat-stroked-button class="searchButton" (click)="searchTrainingGroupGridDataFunction()">
						<i class="fa-solid fa-magnifying-glass"></i> Search
					</button>
					<button mat-stroked-button class="cancelButton"
						(click)="resetSearchTrainingGroupGridDataFunction()">
						<i class="fa fa-repeat"></i> Reset
					</button>
				</div>
			</div>
			<div class="d-none table-container" *ngIf="showTrainingGroupSearchGrid">
				<table class="search-manager-table-container">
					<thead>
						<th style="min-width: 80px; text-align: center"></th>
						<th>
							<span>Group Name</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Description</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>CC Reminder Email To RM</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Is Active?</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th class="sticky-col first-col menu"></th>
					</thead>
					<tbody>
						<tr class="data-row-container" *ngFor="
			  let trainingGroup of searchedTrainingGroupList;
			  let idx = index
			">
							<td style="min-width: 80px; text-align: center">
								<div style="display: flex">
									<div [ngClass]="
					trainingGroup.searchTrainingChildCheckBoxs
					  ? 'static_icon'
					  : 'hover-menu-icons'
				  ">
										<i class="fa-solid fa-ellipsis-vertical"></i>
									</div>
									<div style="margin-left: 5px">
										<input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2"
											[checked]="trainingGroup.searchTrainingChildCheckBoxs" (change)="
					  searchTrainingGroupChildCheckBoxChecked(
						$event,
						trainingGroup,
						idx
					  )
					" />
									</div>
								</div>
							</td>
							<td class="row-data">{{ trainingGroup.groupName }}</td>
							<td class="row-data">{{ trainingGroup.groupDescription }}</td>
							<td class="row-data">{{ trainingGroup.ccReminderEmailToRm }}</td>
							<td class="grid-row-container" style="
				text-align: left;
				overflow: hidden;
				text-overflow: 'ellipsis';
				white-space: 'nowrap';
			  ">
								<span>
									<div class="gridCheckBoxes">
										<img alt="yes" *ngIf="trainingGroup.isActive == 'Y'"
											src="../../assets/img/accessSymbol.svg" width="20" height="20" />
										<img alt="no" *ngIf="trainingGroup.isActive == 'N'"
											src="../../assets/img/noAcessSymbol.svg" width="20" height="20" />
									</div>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="table-container">
				<table class="dynamic-table-container documentTable" style="height: 50vh;">
					<thead>
						<th></th>
						<th
							[ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
							<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
								<span>Group Name</span>
								<div class="d-flex gap-2 align-items-center">
									<div>
										<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
											alt="sort" />
									</div>
								</div>
							</div>
						</th>
						<th
							[ngStyle]="{'min-width': '200px', 'max-width': '200px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
							<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
								<span>Description</span>
								<div class="d-flex gap-2 align-items-center">
									<div>
										<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
											alt="sort" />
									</div>
								</div>
							</div>
						</th>
						<th
							[ngStyle]="{'min-width': '230px', 'max-width': '230px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
							<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
								<span>CC Reminder Email To RM</span>
								<div class="d-flex gap-2 align-items-center">
									<div>
										<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
											alt="sort" />
									</div>
								</div>
							</div>
						</th>
						<th
							[ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
							<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
								<span>Is Active?</span>
								<div class="d-flex gap-2 align-items-center">
									<div>
										<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
											alt="sort" />
									</div>
								</div>
							</div>
						</th>
					</thead>
					<tbody>
						<tr class="data-row-container" *ngFor="
			  let trainingGroup of searchedTrainingGroupList;
			  let idx = index
			">
							<td style="min-width: 80px; text-align: center">
								<div style="display: flex">
									<div [ngClass]="
					trainingGroup.searchTrainingChildCheckBoxs
					  ? 'static_icon'
					  : 'hover-menu-icons'
				  ">
										<i class="fa-solid fa-ellipsis-vertical"></i>
									</div>
									<div style="margin-left: 5px">
										<input id="selectedUserCheck" type="checkbox" style="zoom: 1.2"
											[checked]="trainingGroup.searchTrainingChildCheckBoxs" (change)="
					  searchTrainingGroupChildCheckBoxChecked(
						$event,
						trainingGroup,
						idx
					  )
					" />
									</div>
								</div>
							</td>
							<td class="row-data">{{ trainingGroup.groupName }}</td>
							<td class="row-data">{{ trainingGroup.groupDescription }}</td>
							<td class="row-data">{{ trainingGroup.ccReminderEmailToRm }}</td>
							<td class="grid-row-container" style="
				text-align: left;
				overflow: hidden;
				text-overflow: 'ellipsis';
				white-space: 'nowrap';
			  ">
								<span>
									<div class="gridCheckBoxes">
										<img alt="yes" *ngIf="trainingGroup.isActive == 'Y'"
											src="../../../assets/img/cr_module/accessSymbol.svg" width="16" height="16"
											alt="access" />
										<img alt="no" *ngIf="trainingGroup.isActive == 'N'"
											src="../../../assets/img/cr_module/noAcessSymbol.svg" width="16" height="16"
											alt="no access" />
									</div>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
			<div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
				(click)="addTrainingGroupFunction()" (keydown.enter)="addTrainingGroupFunction()">
				<img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
				<span class="reload_text text-white">Add</span>
			</div>
			<button mat-stroked-button class="cancelButton" (click)="cancelSearchTrainingGroupFunction()">
				<i class="fa fa-close"></i> Cancel
			</button>
		</div>
	</ng-template>
	<ng-template #teamTrainingPopup>
		<div class="ng-template-container">
			<div class="page-loading-shade" *ngIf="isProcessing">
				<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
			</div>
			<button class="close close-button" (click)="cancelTeamTrainingPopup()" mat-button>
				<i class="fa popupClose">&#xf00d;</i>
			</button>

			<div mat-dialog-title>
				<label for="title" class="popupTitle">{{ searchVals }} Trainings</label>
				<label for="pop" class="popupAppTitle">One<span style="color: gold">QMS</span>
				</label>
			</div>
			<div class="form-continer">
				<div class="table-container">
					<div class="header-container" class="row">
						<div class="col-md-4">
							<div class="search-container">
								<span class="fa fa-search form-control-feedback"></span>
								<input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
									[(ngModel)]="searchValue" />
							</div>
						</div>
						<div class="col-md-2"></div>
						<div class="col-6 col-md-6 pr-0 d-flex justify-content-end align-items-center">
							{{ showingRowsText }}
							1-{{ perPage }} of {{ collectionSize | number }}
							<ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
								[disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
								[maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
								[boundaryLinks]="true" size="sm">
							</ngb-pagination>
							<div ngbDropdown class="d-inline-block leftpadding">
								<button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
									{{ perPage }}
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
									<button ngbDropdownItem (click)="paginationCall1(10)">
										10
									</button>
									<button ngbDropdownItem (click)="paginationCall1(20)">
										20
									</button>
									<button ngbDropdownItem (click)="paginationCall1(50)">
										50
									</button>
								</div>
								per page
							</div>
						</div>
					</div>

					<table class="vendors-table-container">
						<th class="grid-header-container" *ngFor="
				let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
				let ix = index
			  " [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width }"
							class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)"
							(focus)="focusEmpty()">
							<div>
								<span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
								<div class="row-search-container">
									<input type="text" class="form-control" placeholder="Search" (input)="
					  applyFilter3(columnLists.columnsListarray[ix], $event)
					" />
								</div>
							</div>
						</th>
						<th  class=" menu sticky-col first-col"></th>
						<tr *ngFor="
				let list of pagedItems | searchFilter : searchValue;
				let idx = index
			  ">
							<td *ngFor="let key of columnLists.columnsListarray1; let i = index"
								class="sticky-dynamic-row1 grid-row-container" [ngStyle]="{
				  'min-width': key.width[i],
				  'max-width': key.width[i],
				  overflow: 'hidden',
				  'text-overflow': 'ellipsis',
				  'white-space': 'nowrap'
				}" (mouseover)="cssfunction(i)" (focus)="focusEmpty()"
 >
								<span *ngIf="key.dataType == 'CHECKBOX'">
									<div class="gridCheckBoxes">
										<img alt="yes"*ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg"
											width="20" height="20" />
										<img alt="no" *ngIf="list[key.columnsListarray] == false"
											src="../../assets/img/noAcessSymbol.svg" width="20" height="20" />
									</div>
								</span>
								<span *ngIf="key.dataType != 'CHECKBOX' && key.dataType != 'DATE'">{{
									list[key.columnsListarray] }}</span>
								<span *ngIf="key.dataType == 'DATE'">{{
									list[key.columnsListarray]
									}}</span>
							</td>
							<td class="sticky-col first-col">
								<div class="action-icons"></div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #trainingProfilepopup>
		<div class="ng-template-container">
			<div class="page-loading-shade" *ngIf="isProcessing">
				<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
			</div>
			<button class="close close-button" (click)="cancelTrainingProfilePopup()" mat-button>
				<i class="fa popupClose">&#xf00d;</i>
			</button>

			<div mat-dialog-title>
				<label for="title" class="popupTitle">{{ trainingProfileTitle }}</label>
				<label for="poptit" class="popupAppTitle">One<span style="color: gold">QMS</span>
				</label>
			</div>
			<div class="form-continer">
				<div *ngIf="trainingProfileTitle == 'Training Categories'">
					<b>Categories : </b><span *ngFor="let category of userAuthorizedCategories; let i = index">{{
						category.trainingCategoryName
						}}<span *ngIf="i != categoryCount - 1">,&nbsp;</span>
					</span>
				</div>
				<div *ngIf="trainingProfileTitle == 'Training Groups'">
					<b>Groups : </b>
					<span *ngFor="let group of userGroups; let i = index">{{ group.groupName }}<span
							*ngIf="i != groupCount - 1">,&nbsp;</span>
					</span>
				</div>
				<div class="table-container" *ngIf="trainingProfileTitle == 'Documents'">
					<div  class="d-none row header-container">
						<div class="col-md-4">
							<div class="row-search-container">
								<input type="text" class="form-control" style="font-size: 13px" placeholder="Search"
									[(ngModel)]="searchValue" />
							</div>
						</div>
						<div class="col-8 col-md-6pr-0 d-flex justify-content-end align-items-center">
							{{ showingRowsText }}
							1-{{ perPage }} of {{ collectionSize | number }}
							<ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
								[disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
								[maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
								[boundaryLinks]="true" size="sm">
							</ngb-pagination>
							<div ngbDropdown class="d-inline-block leftpadding">
								<button class="btn btn-primary btn-sm mr-1 dropdownBasic1" ngbDropdownToggle>
									{{ perPage }}
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
									<button ngbDropdownItem (click)="paginationCall2(10)">
										10
									</button>
									<button ngbDropdownItem (click)="paginationCall2(20)">
										20
									</button>
									<button ngbDropdownItem (click)="paginationCall2(50)">
										50
									</button>
								</div>
								per page
							</div>
						</div>
					</div>
					<table class="d-none dynamic-table-container">
						<th>
							<span>Document No</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Version</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Document Name</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span> Status</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th>
							<span>Type</span>
							<span class="fa-solid fa-filter multi-filter-container"></span>
						</th>
						<th class="sticky-col first-col menu"></th>
						<tr class="data-row-container" *ngFor="
				let document of pagedItems | searchFilter : searchValue;
				let idx = index
			  ">
							<td style="
			  min-width: 140px;
			  color: blue;
			  text-decoration: underline;
			  cursor: pointer;
			" (click)="viewDoc(document)" (keydown.enter)="viewDoc(document)">
								{{ document.documentNo }}
							</td>
							<td class="row-data">{{ document.version }}</td>
							<td class="row-data">{{ document.documentName }}</td>
							<td class="row-data">{{ document.status }}</td>
							<td class="row-data">{{ document.documentTypeName }}</td>
						</tr>
					</table>
					<div class="table-container">
						<div  class="d-flex justify-content-end gap-3 mt-1 mb-3 header-container">
							<div class="">
								<div class="search-container">
									<input type="text" class="form-control search_input" style="font-size: 13px;"
										placeholder="Search" [(ngModel)]="searchValue">
								</div>
							</div>
						</div>
						<table class="dynamic-table-container documentTable">
							<th
								[ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Document No.</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '120px', 'max-width': '120px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Version</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '180px', 'max-width': '180px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Document Name</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Status</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<th
								[ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
								<div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
									<span>Type</span>
									<div class="d-flex gap-2 align-items-center">
										<div>
											<img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
												alt="sort" />
										</div>
									</div>
								</div>
							</th>
							<tr class="data-row-container" *ngFor="
			let document of pagedItemsForDoc | searchFilter : searchValue;
			let idx = index
		  ">
								<td class="row-data" style="
		  min-width: 140px;
		  color: blue;
		  text-decoration: underline;
		  cursor: pointer;
		" (click)="viewDoc(document)" (keydown.enter)="viewDoc(document)">
									{{ document.documentNo }}
								</td>
								<td class="row-data">{{ document.version }}</td>
								<td class="row-data">{{ document.documentName }}</td>
								<td class="row-data">{{ document.status }}</td>
								<td class="row-data">{{ document.documentTypeName }}</td>
							</tr>
						</table>
						<div class="d-flex justify-content-center">
							<div class="width-cheat small paginationCell">
								<div class="d-flex align-items-center gap-3">
									<div class="pagination_text mt-3">
										{{ showingRowsText }}
										1-{{ perPage }} of {{ collectionSize | number }}
									</div>
									<div>
										<ngb-pagination class="leftpadding"
											(pageChange)="setPage2(pager.currentPage, $event)" [disabled]="false"
											[collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
											[maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
											[boundaryLinks]="true" size="sm">
										</ngb-pagination>
									</div>
									<div ngbDropdown class="mt-3">
										<button class="btn btn-primary btn-sm mr-1 bg-white pagination_text dropdownBasic1" ngbDropdownToggle>
											{{ perPage }}
											<i class="ms-1 fa-solid fa-chevron-down"></i>
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
											<button ngbDropdownItem (click)="paginationCall2(10)">10</button>
											<button ngbDropdownItem (click)="paginationCall2(20)">20</button>
											<button ngbDropdownItem (click)="paginationCall2(50)">50</button>
										</div>
										per page
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template #confirmWithReasonPopup>
		<div class="page-loading-shade" *ngIf="isProcessing">
			<app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
		</div>
		<button class="close close-button" (click)="cancelFunc()" mat-button>
			<i class="fa popupClose">&#xf00d;</i>
		</button>
		<div mat-dialog-title>
			<label for="title" class="popupTitle"> {{title}}</label>
			<label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
			</label>
		</div>
		<div style="margin: 15px 15px;">
			<div>
				<div class="row" *ngIf="tmsSettingsObj.esignatureAtTrainingUnlock =='N'">
					Are you sure, you want to unlock the training?
				</div>
				<div class="row" *ngIf="tmsSettingsObj.esignatureAtTrainingUnlock =='Y'">
					<div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
					</div>
					<div> <input id="username" style="height: 70% !important;" class="input-filed-continers" type="text"
							[(ngModel)]="userName" disabled>
					</div>
				</div>
				<div class="row" *ngIf="(tmsSettingsObj.esignatureAtTrainingUnlock =='Y' && !isAdenabled)">
					<div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
					<div> <input id="pass" style="height: 70% !important;" class="input-filed-continers"
							[type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
							noCopyPaste>
						<span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
							<i
								[class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
						</span>
					</div>
					<span id="pass-required-msg">Please enter password</span>
				</div>
				<div class="row" *ngIf="isShowDueDate">
					<div><label for="username ">Due Date</label></div>
					<div>
						<input type="text" style="height: 70% !important;" class="form-control data-picker-continer"
							bsDatepicker [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
							[(ngModel)]="dueDate">
					</div>
				</div>
				<br>
			</div>
			<div class="button-continer" mat-dialog-actions>
				<button mat-stroked-button class="addButton" (click)="confirmWithFunc()">
					OK
				</button>
				<button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
					<i class="fa fa-close"></i> Cancel
				</button>
			</div>
		</div>
	</ng-template>


	<!--Excell & pdf -->
	<ng-template #excelPdfPopup>

		<button class="close close-button" (click)="cancelReportPopup()" mat-button><i
				class="fa popupClose">&#xf00d;</i></button>
		<div mat-dialog-title>
			<label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
			<label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
		</div>
		<div style="margin: 15px 15px;" class="align-center">
			<label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{
				popupDataTitle.title }}
				?</label>
		</div>
		<div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
			<label for="email" style="font-size: .7rem; font-weight: bold;">
				<span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
				<span *ngIf="manuallyPicked && maxCountReached">
					We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
				</span>
			</label>
		</div>
		<div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
			<div class="col-md-12" *ngIf="selectedColumns.length">
				<div><label for="email">Selected Column(s)</label></div>
				<textarea id="selectedValuesTextarea" class="input-filed-textarea"
					style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
					[(ngModel)]="selectedColumnsAsString"></textarea>
			</div>
			<div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
				<div class="col-md-6">
					<label for="radio">PDF Page Size</label>
					<mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
						<mat-radio-button *ngFor="let data of pdfPageSizes"
							[value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="col-md-6" style="margin-top: 1.5%;">
					<label for="toggle">Pick Columns Manually?</label>&nbsp;
					<mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
						id="toggle">
						<ng-container *ngIf="manuallyPicked; else no">
							<span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
						</ng-container>
						<ng-template #no>
							<span style="color: red;">No</span>
						</ng-template>
					</mat-slide-toggle>
				</div>
			</div>
			<div class="row mt-3" *ngIf="manuallyPicked">
				<div class="col-md-12">
					<div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
					<mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
						(closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')" (keydown.enter)="focusSearch('focus-department-search')">
						<input type="search" id="focus-department-search" class="dropdownsearchstyle"
							[(ngModel)]="pdfSearchText" matInput placeholder="search">
						<div class="select-all">
							<mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select
								All</mat-checkbox>
						</div>
						<mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
							[value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
							{{ item.displayExp }}
						</mat-option>
					</mat-select>
				</div>
			</div>
			<div class="row justify-content-md-center">
				<div class="col-sm-4">
					<label id="reportLogo-validation" for="email">Report Logo</label>
				</div>
				<div class="col-sm-8">
					<mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
						(closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
						(keydown.enter)="focusSearch('focus-Logo-search')">
						<input type="search" id="focus-Logo-search" class="dropdownsearchstyle"
							[(ngModel)]="pdfDetailSearchText" matInput placeholder="search">
						<mat-option [value]="null" class="unselectStyle"
							(onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
						<mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
							(onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
							{{ item.displayExp }}
						</mat-option>
					</mat-select>
				</div>
			</div>
			<div class="row justify-content-md-center">
				<div class="col-sm-4">
					<label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
				</div>
				<div class="col-sm-8">
					<mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
						(closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
						(keydown.enter)="focusSearch('focus-Logo-search')">
						<input type="search" id="focus-footer-search" class="dropdownsearchstyle"
							[(ngModel)]="pdfDetailSearchText" matInput placeholder="search">

						<mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
							(onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
							{{ item.displayExp }}
						</mat-option>
					</mat-select>
				</div>
			</div>
			<div class="row justify-content-md-center">
				<div class="col-sm-4">
					<label id="prtLogo-validation" for="email">Is Save Report?</label>
				</div>
				<div class="col-sm-8">
					<mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
						<ng-container *ngIf="isSaveReport; else noisSaveReport">
							<span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
						</ng-container>
						<ng-template #noisSaveReport>
							<span style="color: red;">No</span>
						</ng-template>
					</mat-slide-toggle>
				</div>
			</div>
			<div class="row justify-content-md-center" *ngIf="isSaveReport">
				<div class="col-sm-4">
					<label id="rprtLogo-validation" for="email">Report Name</label>
				</div>
				<div class="col-sm-8">
					<input type="text" class="input-filed-continers" [(ngModel)]="reportName">
				</div>
			</div>

		</div>
		<div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
			<button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
				<i class="fa fa-file-pdf-o"></i> Generate
			</button>
			<button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
				<i class="fa fa-close"></i> Cancel
			</button>
		</div>
	</ng-template>
	<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
	<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
	<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>